import React, { useState, useEffect } from "react";
import Breadcrumb from "../../components/common/Breadcrumb";
import { IconCheck, IconX } from "@tabler/icons-react";
import {
  getCategorys,
  getCompanys,
  getDepartments,
  getDesignation,
  getGroup,
  GetMusterRoll,
  getProfitCenter,
} from "../../services/dataService";
import jsPDF from "jspdf";
import * as XLSX from "xlsx";
import "jspdf-autotable";
import toast from "react-hot-toast";
import { getSecureItem } from "../../services/SecureStorage";

export default function Musterrole() {
 const [selectedMonth, setSelectedMonth] = useState(() => {
    const storedMonth = sessionStorage.getItem("selectedMonth");
    return storedMonth || new Date().toISOString().slice(0, 7); // Fallback to current month
  });
  const [dates, setDates] = useState({
    FromDate: "",
    ToDate: "",
  });
 
  const [isadminDepName, setIsadminDepName] = useState("");
  const [musterRoll, setMusterRoll] = useState([]);
  const [loading, setLoading] = useState(false);
  const [daysInMonth, setDaysInMonth] = useState(0);
  const [datafilter, setDataFilter] = useState([]);
  const [category, setCategory] = useState([]);
  const [designation, setdesignation] = useState([]);
  const [filterMethod, setFilterMethod] = useState("");
  const [dropdownOptions, setDropdownOptions] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [group, setGroup] = useState([]);
  const [Department, setDepartment] = useState([]);
  const [selectodMethodName, setSelectedMethodName] = useState("");
  const [FilterProfitcenter, setFilterProfitcenter] = useState([]);
  const UID = getSecureItem("userId");
  const isAdmin = getSecureItem("IsAdmin");
  const departmentIds = getSecureItem("DepartmentId") || ""; // Retrieve the value or default to an empty string
  const DepId = departmentIds.split(",")[0] || null; // Split and get the first ID, or set to null if not found
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const [EmpId, setEmpId] = useState(null);
  const [sessionDate, setSessionDate] = useState(null);
  useEffect(() => {
    const PayrollDate = sessionStorage.getItem("selectedMonth");
    setSessionDate(PayrollDate);
  }, []);

 useEffect(() => {
  if (sessionDate) {
    setSelectedMonth(sessionDate);
  }
}, [sessionDate]);
  useEffect(() => {
    const id = sessionStorage.getItem("EmpId");
    setEmpId(id);
  }, []);
  const [companyDetails, setCompanyDetails] = useState([]);

  const fetchCompanyDetails = async () => {
    try {
      const response = await getCompanys(UID);
      setCompanyDetails(response.data.data[0]);
    } catch (error) {
      console.error("An error occurred:", error);
      toast.error("An error occurred while fetching company details");
    }
  };

  useEffect(() => {
    fetchCompanyDetails();
  }, []);

  useEffect(() => {
    if (!selectedMonth) return;
    const [year, month] = selectedMonth.split("-")?.map(Number);
    const firstDay = new Date(year, month - 1, 1);
    const lastDay = new Date(year, month, 0);
    const formatDate = (date) => {
      const y = date.getFullYear();
      const m = String(date.getMonth() + 1).padStart(2, "0");
      const d = String(date.getDate()).padStart(2, "0");
      return `${y}-${m}-${d}`;
    };
    setDates({
      FromDate: formatDate(firstDay),
      ToDate: formatDate(lastDay),
    });
    setDaysInMonth(lastDay.getDate());
  }, [selectedMonth]);

  const fetchMusterrollData = async () => {
    if (!dates.FromDate || !dates.ToDate) return;

    const data = {
      FromDate: dates.FromDate,
      ToDate: dates.ToDate,
      UserId: UID,
    };

    try {
      setLoading(true);
      const response = await GetMusterRoll(data);

      let details =
        isAdmin == 1
          ? response?.data?.data
          : response?.data?.data?.filter((el) => el?.DEPARTMENTID == DepId);

      // ✅ Filter by EmpId if provided
      if (EmpId) {
        details = details.filter((el) => el.EMPLOYEEID == EmpId);
      }

      // ✅ Parse nested JSON fields
      details = details.map((item) => {
        const attendanceRaw = item?.AttendanceData
          ? JSON.parse(item.AttendanceData)
          : [];
        const WeeklyOff = attendanceRaw.filter((el) => el.IsWeekly === true);
        const attendance = attendanceRaw.filter((el) => el.IsWeekly !== true);

        return {
          ...item,
          AttendanceData: attendance,
          Leaves: item?.Leaves ? JSON.parse(item.Leaves) : [],
          Holidays: item?.Holidays ? JSON.parse(item.Holidays) : [],
          WeeklyOff: WeeklyOff,
        };
      });

      setMusterRoll(details);
    } catch (error) {
      console.error("Error fetching attendance data", error);
    } finally {
      setLoading(false);
    }
  };

  const claerSession = () => {
    sessionStorage.removeItem("EmpId");
    setEmpId(null); // reset state
  };

  // React will auto-trigger this when EmpId updates
  useEffect(() => {
    // Fetch only if dates are selected
    if (!EmpId || dates.FromDate || dates.ToDate) {
      fetchMusterrollData();
    }
  }, [EmpId]);

  useEffect(() => {
    fetchMusterrollData();
  }, [dates, UID]);

  const handleMonthChange = (e) => {
    setSelectedMonth(e.target.value);
  };

  const groupByEmployee = (data) => {
    const grouped = {};
    let year, month;

    if (typeof selectedMonth === "string" && selectedMonth.includes("-")) {
      [year, month] = selectedMonth.split("-").map(Number);
    } else {
      const today = new Date();
      year = today.getFullYear();
      month = today.getMonth() + 1;
    }
    const lastDay = new Date(year, month, 0).getDate();
    const monthStart = new Date(year, month - 1, 1);
    const monthEnd = new Date(year, month, 0);
    monthStart.setHours(0, 0, 0, 0);
    monthEnd.setHours(23, 59, 59, 999);

    data?.forEach((item) => {
      if (!grouped[item.EMPLOYEEID]) {
        grouped[item.EMPLOYEEID] = {
          ...item,
          employee: item.EmployeeName,
          labourId: item.EmployeeCode,
          gender: item.GenderName,
          dateOfJoin: item.DOJ
            ? new Date(item.DOJ).toISOString().split("T")[0]
            : "N/A",
          department: item.DepartmentName,
          category: item.CategoryName,
          designation: item.DesignationName,
          status: item.ShiftName,
          attendance: {},
          leaveDays: [],
          holidayDays: [],
          leaveDetails: {},
          holidayDetails: {},
          totalPresent: 0,
          totalAbsent: 0,
          totalHolidays: 0,
          totalCasualLeave: 0,
          totalSickLeave: 0,
          totalAnnualLeave: 0,
          totalMaternityLeave: 0,
          totalSpecialLeave: 0,
          totalYellowppi: 0,
          totalMorningHalfDay: 0,
          totalEveningHalfDay: 0,
          weeklyOff: 0,
          weeklyOffDays: new Set(), // Track unique Weekly Off days
          totalDays: lastDay,
        };
      }

      if (item.AttendanceData?.length > 0 || item.WeeklyOff?.length > 0) {
        const attendanceByDate = {};
        item.AttendanceData.forEach((attendance) => {
          const recordDate = attendance.RECORDDATE;
          if (recordDate) {
            const date = new Date(recordDate).getDate();
            if (!attendanceByDate[date] || attendance.ATTENDANCESTATUS == 1) {
              attendanceByDate[date] = attendance;
            }
          }
        });

        item.WeeklyOff.forEach((attendance) => {
          const recordDate = attendance.RECORDDATE;
          if (recordDate) {
            const recordDateObj = new Date(recordDate);
            recordDateObj.setHours(12, 0, 0, 0);
            if (recordDateObj >= monthStart && recordDateObj <= monthEnd) {
              const date = recordDateObj.getDate();
              grouped[item.EMPLOYEEID].weeklyOffDays.add(date); // Add to Set for uniqueness
              attendanceByDate[date] = {
                ...attendance,
                IsWeekly: true,
              };
            }
          }
        });

        Object.values(attendanceByDate).forEach((attendance) => {
          const date = new Date(attendance.RECORDDATE).getDate();
          if (attendance?.IsWeekly === true) {
            grouped[item.EMPLOYEEID].attendance[date] = "WO";
          } else if (attendance.ATTENDANCESTATUS !== undefined) {
            grouped[item.EMPLOYEEID].attendance[date] =
              attendance.ATTENDANCESTATUS === 1;
          }
        });

        // Set weeklyOff to the number of unique Weekly Off days
        grouped[item.EMPLOYEEID].weeklyOff =
          grouped[item.EMPLOYEEID].weeklyOffDays.size;
      }

      if (item.Holidays && item.Holidays.length > 0) {
        item.Holidays.forEach((holiday) => {
          if (holiday.EventDate) {
            const holidayDate = new Date(holiday.EventDate);
            holidayDate.setHours(12, 0, 0, 0);
            if (holidayDate >= monthStart && holidayDate <= monthEnd) {
              const day = holidayDate.getDate();
              if (!grouped[item.EMPLOYEEID].holidayDays.includes(day)) {
                grouped[item.EMPLOYEEID].holidayDays.push(day);
                grouped[item.EMPLOYEEID].holidayDetails[day] = holiday.Name;
                grouped[item.EMPLOYEEID].totalHolidays++;
              }
            }
          }
        });
      }

      if (item.Leaves && item.Leaves.length > 0) {
        item?.Leaves?.forEach((leave) => {
          if (
            leave.LeaveStatus === 1 &&
            leave.LeaveStartDate &&
            leave.LeaveEndDate
          ) {
            const startDate = new Date(leave.LeaveStartDate);
            const endDate = new Date(leave.LeaveEndDate);
            if (endDate >= monthStart && startDate <= monthEnd) {
              const adjustedStart = Math.max(
                startDate < monthStart ? 1 : startDate.getDate(),
                1
              );
              const adjustedEnd = Math.min(
                endDate > monthEnd ? monthEnd.getDate() : endDate.getDate(),
                monthEnd.getDate()
              );
              for (let day = adjustedStart; day <= adjustedEnd; day++) {
                if (!grouped[item.EMPLOYEEID].holidayDays.includes(day)) {
                  if (!grouped[item.EMPLOYEEID].leaveDays.includes(day)) {
                    grouped[item.EMPLOYEEID].leaveDays.push(day);
                    grouped[item.EMPLOYEEID].leaveDetails[day] =
                      leave.LeaveTypeName;
                    switch (leave.LeaveTypeName) {
                      case "Absent":
                        grouped[item.EMPLOYEEID].totalYellowppi++;
                        break;
                      case "Casual":
                        grouped[item.EMPLOYEEID].totalCasualLeave++;
                        break;
                      case "Sick":
                        grouped[item.EMPLOYEEID].totalSickLeave++;
                        break;
                      case "Annual leave":
                        grouped[item.EMPLOYEEID].totalAnnualLeave++;
                        break;
                      case "Special Leave":
                        grouped[item.EMPLOYEEID].totalSpecialLeave++;
                        break;
                      case "Maternity Leave":
                        grouped[item.EMPLOYEEID].totalMaternityLeave++;
                        break;
                      case "Morning HalfDay":
                        grouped[item.EMPLOYEEID].totalMorningHalfDay++;
                        break;
                      case "Evening HalfDay":
                        grouped[item.EMPLOYEEID].totalEveningHalfDay++;
                        break;
                    }
                  }
                }
              }
            }
          }
        });
      }
    });

    Object.values(grouped).forEach((employee) => {
      for (const [day, status] of Object.entries(employee.attendance)) {
        const dayNum = parseInt(day, 10);
        if (
          !employee.holidayDays.includes(dayNum) &&
          !employee.leaveDays.includes(dayNum)
        ) {
          if (status === true) employee.totalPresent++;
          else if (status === false) employee.totalAbsent++;
        }
      }
      const totalAccountedDays =
        employee.totalPresent +
        employee.totalHolidays +
        (employee.totalCasualLeave +
          employee.totalMaternityLeave +
          employee.totalSpecialLeave +
          employee.totalSickLeave +
          employee.totalAnnualLeave +
          employee.totalYellowppi +
          employee.totalMorningHalfDay +
          employee.totalEveningHalfDay) +
        employee.weeklyOff;
      employee.totalAbsent = Math.max(
        0,
        employee.totalDays - totalAccountedDays
      );
      delete employee.weeklyOffDays; // Clean up temporary Set
    });

    return Object.values(grouped);
  };

  const formatAttendanceData = () => {
    if (!musterRoll.length || !daysInMonth) return [];
    const groupedData = groupByEmployee(musterRoll);
    return groupedData.map((employee) => {
      const children = Array.from({ length: daysInMonth }, (_, index) => {
        const day = index + 1;
        if (employee.holidayDays.includes(day)) {
          return {
            status: "H",
            holidayName: employee.holidayDetails[day] || "Holiday",
          };
        }
        if (employee.attendance[day] === "WO") {
          return {
            status: "wo",
            WeeklyOff: "Weekly Off",
          };
        }
        if (employee.leaveDays.includes(day)) {
          const leaveType = employee.leaveDetails[day];
          return {
            status: leaveType === "Absent" ? "LWA" : "L",
            leaveType: leaveType,
          };
        }
        if (employee.attendance?.[day] !== undefined) {
          return {
            status: employee.attendance[day] ? "P" : "A",
          };
        }
        return { status: "A" };
      });
      return { ...employee, children };
    });
  };

  const renderStatusIcon = (status, leaveType, holidayName, WeeklyOff) => {
    switch (status) {
      case "wo":
        return (
          <span
            className="text-gray-500 font-bold"
            title={WeeklyOff || "Weekly Off"}
          >
            WO
          </span>
        );
      case "P":
        return (
          <IconCheck className="w-[18px] h-[18px] stroke-[2.5] text-success" />
        );
      case "A":
        return <IconX className="w-[18px] h-[18px] stroke-[2.5] text-danger" />;
      case "LWA":
        return <span className="text-yellow-500 font-bold">LWA</span>;
      case "L":
        return (
          <span className="text-blue-500 font-bold">
            {leaveType === "Sick"
              ? "SL"
              : leaveType === "Annual leave"
              ? "AL"
              : leaveType === "Casual"
              ? "CL"
              : leaveType === "Maternity Leave"
              ? "ML"
              : leaveType === "Special Leave"
              ? "SP"
              : leaveType === "Morning HalfDay"
              ? "MH"
              : leaveType === "Evening HalfDay"
              ? "EH"
              : "L"}
          </span>
        );
      case "H":
        return (
          <span className="font-bold" title={holidayName || "Holiday"}>
            H
          </span>
        );
      default:
        return null;
    }
  };

  useEffect(() => {
    const fetchcategory = async () => {
      try {
        const response = await getCategorys(UID);
        setCategory(response);
      } catch (error) {
        console.error("Error fetching cate:", error);
      }
    };
    fetchcategory();
  }, [UID]);

  useEffect(() => {
    const fetchdesignation = async () => {
      try {
        const response = await getDesignation(UID);
        setdesignation(response);
      } catch (error) {
        console.error("Error fetching cate:", error);
      }
    };
    fetchdesignation();
  }, [UID]);

  useEffect(() => {
    const fetchGroup = async () => {
      try {
        const response = await getGroup(UID);
        setGroup(response);
      } catch (error) {
        console.error("Error fetching cate:", error);
      }
    };
    fetchGroup();
  }, [UID]);

  useEffect(() => {
    const fetchDepartment = async () => {
      try {
        const response = await getDepartments(UID);
        console.log(response.data.data, "ssdadsas");

        setDepartment(response.data.data);
      } catch (error) {
        console.error("Error fetching cate:", error);
      }
    };
    fetchDepartment();
  }, [UID]);

  useEffect(() => {
    const fetchfilterProfitecenter = async () => {
      try {
        const response = await getProfitCenter(UID);
        setFilterProfitcenter(response);
      } catch (error) {
        console.error("Error fetching cate:", error);
      }
    };
    fetchfilterProfitecenter();
  }, []);

  useEffect(() => {
    switch (filterMethod) {
      case "CategoryId":
        setDropdownOptions(category?.data?.data);
        break;
      case "ProfitCenterID":
        setDropdownOptions(FilterProfitcenter?.data?.data);
        break;
      case "GroupId":
        setDropdownOptions(group?.data?.data);
        break;
      case "DesignationId":
        setDropdownOptions(designation?.data?.data);
        break;
      case "DepartmentID":
        setDropdownOptions(Department);
        break;
      default:
        setDropdownOptions([]);
        break;
    }
  }, [
    filterMethod,
    category,
    FilterProfitcenter,
    group,
    designation,
    Department,
  ]);

  const handleFilterChange = (selectedMethod, selectedOptionName) => {
    setFilterMethod(selectedMethod);
    const formattedData = formatAttendanceData();
    let filteredData = [...formattedData];
    if (selectedMethod === "DepartmentID") {
      filteredData = filteredData?.filter(
        (item) => item.department === selectedOptionName
      );
    } else if (selectedMethod === "DesignationId") {
      filteredData = filteredData?.filter(
        (item) => item.designation === selectedOptionName
      );
    } else if (selectedMethod === "ProfitCenterID") {
      filteredData = filteredData?.filter(
        (item) => item.ProfitcenterName === selectedOptionName
      );
    } else if (selectedMethod === "CategoryId") {
      filteredData = filteredData?.filter(
        (item) => item.category === selectedOptionName
      );
    } else if (selectedMethod === "GroupId") {
      filteredData = filteredData?.filter(
        (item) => item.GroupName === selectedOptionName
      );
    }
    setSelectedMethodName(selectedOptionName);
    setDataFilter(filteredData);
  };

  const handleClearFilter = () => {
    setSelectedMethodName("");
    setFilterMethod("");
    const formattedData = formatAttendanceData();
    setDataFilter(formattedData);
  };

  useEffect(() => {
    const formattedData = formatAttendanceData();
    setDataFilter(formattedData);
  }, [musterRoll]);

  const filteredItems = datafilter?.filter((el) =>
    `${el.employee} ${el.labourId} ${el.department} ${el.designation} ${el.category}`
      .toLowerCase()
      .includes(searchText.toLowerCase())
  );

  useEffect(() => {
    if (Array.isArray(Department)) {
      const name = Department.find((el) => el.Id === DepId)?.Name || "";
      setIsadminDepName(name);
    }
  }, [Department, DepId]);
  const exportToPdf = (selectedOptionName) => {
    console.log(selectedOptionName, "dhjsjfjds");
    console.log(isadminDepName, "dhjsjfjds");

    if (!filteredItems || filteredItems.length === 0) {
      alert("No data to export");
      return;
    }

    const doc = new jsPDF({
      orientation: "landscape",
      unit: "pt",
      format: "a3",
    });

    const monthYear = selectedMonth
      ? new Date(selectedMonth).toLocaleString("default", {
          month: "long",
          year: "numeric",
        })
      : "";

    const pageWidth = doc.internal.pageSize.getWidth();
    doc.setFontSize(18);

    const reportTitle = `${companyDetails.Name.toUpperCase()} Muster Roll Report - ${monthYear}`;
    const fullTitle =
      isAdmin == 1
        ? `${reportTitle} - ${selectedOptionName || ""}`
        : `${reportTitle} - ${isadminDepName} - ${selectedOptionName || ""}`;

    doc.text(fullTitle.toUpperCase(), pageWidth / 2, 30, { align: "center" });

    // Attendance definitions in two-row table (short forms and full forms)
    const attendanceDefinitions = [
      { short: "P", full: "Attendance Approved" },
      { short: "A", full: "Attendance Not Approved" },
      { short: "LWA", full: "Absent" },
      { short: "H", full: "Holiday" },
      { short: "WO", full: "Weekly Off" },
      { short: "CL", full: "Casual Leave" },
      { short: "SL", full: "Sick Leave" },
      { short: "AL", full: "Annual Leave" },
      { short: "ML", full: "Maternity Leave" },
      { short: "SP", full: "Special Leave" },
      { short: "MH", full: "Morning HalfDay" },
      { short: "EH", full: "Evening HalfDay" },
    ];

    // Create a 12-column table for attendance definitions (no header to avoid double lines)
    const defShortRow = attendanceDefinitions
      .map((def) => def.short)
      .concat(Array(12 - attendanceDefinitions.length).fill(""));
    const defFullRow = attendanceDefinitions
      .map((def) => def.full)
      .concat(Array(12 - attendanceDefinitions.length).fill(""));
    const defTableData = [defShortRow, defFullRow];

    // Calculate main table width first to match it
    const headers = [
      "SL",
      "E_Name",
      "E_Code",
      "Gender",
      "DOJ",
      "Category",
      "Designation",
      "P",
      "A",
      "H",
      "WO",
      "LWA",
      "CL",
      "AL",
      "SL",
      "SP",
      "ML",
      "MH",
      "EH",
      ...Array.from({ length: daysInMonth }, (_, i) => (i + 1).toString()),
    ];

    const columnStyles = {};
    columnStyles[0] = { cellWidth: 20 }; // SL
    columnStyles[1] = { cellWidth: 80 }; // E_Name
    columnStyles[2] = { cellWidth: 50 }; // E_Code
    columnStyles[3] = { cellWidth: 35 }; // Gender
    columnStyles[4] = { cellWidth: 50 }; // DOJ
    columnStyles[5] = { cellWidth: 60 }; // Category
    columnStyles[6] = { cellWidth: 70 }; // Designation
    columnStyles[7] = { cellWidth: 20 }; // P
    columnStyles[8] = { cellWidth: 20 }; // A
    columnStyles[9] = { cellWidth: 20 }; // H
    columnStyles[10] = { cellWidth: 20 }; // WO
    columnStyles[11] = { cellWidth: 25 }; // LWA
    columnStyles[12] = { cellWidth: 20 }; // CL
    columnStyles[13] = { cellWidth: 20 }; // AL
    columnStyles[14] = { cellWidth: 20 }; // SL
    columnStyles[15] = { cellWidth: 20 }; // SP
    columnStyles[16] = { cellWidth: 20 }; // ML
    columnStyles[17] = { cellWidth: 20 }; // MH
    columnStyles[18] = { cellWidth: 20 }; // EH
    for (let i = 19; i < headers.length; i++) {
      columnStyles[i] = { cellWidth: 16 }; // Day columns
    }

    let totalTableWidth = 0;
    for (let i = 0; i < headers.length; i++) {
      totalTableWidth += columnStyles[i]?.cellWidth || 16;
    }

    // Set hints table to match main table width, distributed across 12 columns
    const defColumnWidth = totalTableWidth / 12;
    const defColumnStyles = Array(12)
      .fill({})
      .reduce((acc, _, index) => {
        acc[index] = { cellWidth: defColumnWidth };
        return acc;
      }, {});

    doc.setFontSize(9);
    doc.autoTable({
      body: defTableData, // No head to avoid double lines
      startY: 50,
      styles: {
        fontSize: 9,
        cellPadding: 3,
        lineWidth: 0.3,
        lineColor: [0, 0, 0],
        halign: "center",
        valign: "middle",
        overflow: "linebreak",
      },
      bodyStyles: {
        fillColor: [255, 255, 255], // White background
        minCellHeight: 15,
      },
      columnStyles: defColumnStyles,
      margin: {
        left: (pageWidth - totalTableWidth) / 2,
        right: (pageWidth - totalTableWidth) / 2,
      },
      tableWidth: totalTableWidth,
      didDrawCell: (data) => {
        doc.setDrawColor(0, 0, 0);
        doc.setLineWidth(0.3);
        doc.rect(
          data.cell.x,
          data.cell.y,
          data.cell.width,
          data.cell.height,
          "S"
        );
      },
    });

    let startYz = doc.lastAutoTable.finalY + 20;

    const groupedByDepartment = {};
    filteredItems.forEach((item) => {
      if (!groupedByDepartment[item.department]) {
        groupedByDepartment[item.department] = [];
      }
      groupedByDepartment[item.department].push(item);
    });

    let startY = startYz;
    let currentSl = 1;

    Object.entries(groupedByDepartment).forEach(
      ([department, employees], deptIndex) => {
        if (deptIndex > 0) {
          startY += 20;
        }

        if (isAdmin == 1) {
          doc.setFontSize(14);
          doc.setFont(undefined, "bold");
          doc.text(`Department: ${department}`, 20, startY);
          startY += 20;
        }

        const data = employees.map((employee) => {
          const rowData = [
            currentSl++,
            employee.employee,
            employee.labourId,
            employee.gender,
            employee.dateOfJoin,
            employee.category,
            employee.designation,
            employee.totalPresent,
            employee.totalAbsent,
            employee.totalHolidays,
            employee.weeklyOff,
            employee.totalYellowppi,
            employee.totalCasualLeave,
            employee.totalAnnualLeave,
            employee.totalSickLeave,
            employee.totalSpecialLeave,
            employee.totalMaternityLeave,
            employee.totalMorningHalfDay,
            employee.totalEveningHalfDay,
            ...employee.children.map((child) => {
              switch (child.status) {
                case "P":
                  return "P";
                case "A":
                  return "A";
                case "wo":
                  return "WO";
                case "LWA":
                  return "LWA";
                case "H":
                  return "H";
                case "L":
                  return child.leaveType === "Sick"
                    ? "SL"
                    : child.leaveType === "Annual leave"
                    ? "AL"
                    : child.leaveType === "Casual"
                    ? "CL"
                    : child.leaveType === "Special Leave"
                    ? "SP"
                    : child.leaveType === "Maternity Leave"
                    ? "ML"
                    : child.leaveType === "Morning HalfDay"
                    ? "MH"
                    : child.leaveType === "Evening HalfDay"
                    ? "EH"
                    : "L";
              }
            }),
          ];
          return rowData;
        });

        const leftMargin = Math.max(20, (pageWidth - totalTableWidth) / 2);

        doc.autoTable({
          head: [headers],
          body: data,
          startY: startY,
          styles: {
            fontSize: 8,
            cellPadding: 3,
            lineWidth: 0.3,
            lineColor: [0, 0, 0],
            halign: "center",
            valign: "middle",
            overflow: "linebreak",
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            fontStyle: "bold",
          },
          bodyStyles: {
            fillColor: [255, 255, 255],
            minCellHeight: 20,
          },
          alternateRowStyles: {
            fillColor: [255, 255, 255],
          },
          columnStyles: columnStyles,
          margin: { left: leftMargin, right: leftMargin },
          pageBreak: "auto",
          tableWidth: totalTableWidth,
          didDrawCell: (data) => {
            doc.setDrawColor(0, 0, 0);
            doc.setLineWidth(0.3);
            doc.rect(
              data.cell.x,
              data.cell.y,
              data.cell.width,
              data.cell.height,
              "S"
            );
          },
        });

        startY = doc.lastAutoTable.finalY + 10;
      }
    );

    doc.save(`MusterRoll_${selectedMonth || "report"}.pdf`);
  };

  const goToPage = (pageIndex) => {
    setCurrentPage(pageIndex);
  };

  const exportToExcel = () => {
    if (!filteredItems || filteredItems.length === 0) {
      alert("No data to export");
      return;
    }
    const headers = [
      "SL",
      "E_Name",
      "E_Code",
      "Gender",
      "DOJ",
      "Category",
      "Designation",
      "P",
      "A",
      "H",
      "WO",
      "LWA",
      "CL",
      "AL",
      "SL",
      "SP",
      "ML",
      "MH",
      "EH",
      ...Array.from({ length: daysInMonth }, (_, i) => (i + 1).toString()),
    ];
    const groupedByDepartment = {};
    filteredItems.forEach((item) => {
      if (!groupedByDepartment[item.department]) {
        groupedByDepartment[item.department] = [];
      }
      groupedByDepartment[item.department].push(item);
    });
    const wb = XLSX.utils.book_new();
    let currentSl = 1;
    Object.entries(groupedByDepartment).forEach(([department, employees]) => {
      const sanitizedDepartment = department.replace(/[:\\\/\?\*\[\]]/g, "_");
      const data = employees.map((employee) => {
        const rowData = [
          currentSl++,
          employee.employee,
          employee.labourId,
          employee.gender,
          employee.dateOfJoin,
          employee.category,
          employee.designation,
          employee.totalPresent,
          employee.totalAbsent,
          employee.totalHolidays,
          employee.weeklyOff,
          employee.totalYellowppi,
          employee.totalCasualLeave,
          employee.totalAnnualLeave,
          employee.totalSickLeave,
          employee.totalSpecialLeave,
          employee.totalMaternityLeave,
          employee.totalMorningHalfDay,
          employee.totalEveningHalfDay,
          ...employee.children.map((child) => {
            switch (child.status) {
              case "P":
                return "P";
              case "A":
                return "A";
              case "wo":
                return "WO";
              case "LWA":
                return "LWA";
              case "H":
                return "H";
              case "L":
                return child.leaveType === "Sick"
                  ? "SL"
                  : child.leaveType === "Annual leave"
                  ? "AL"
                  : child.leaveType === "Casual"
                  ? "CL"
                  : child.leaveType === "Special Leave"
                  ? "SP"
                  : child.leaveType === "Maternity Leave"
                  ? "ML"
                  : child.leaveType === "Morning HalfDay"
                  ? "MH"
                  : child.leaveType === "Evening HalfDay"
                  ? "EH"
                  : "L";
              default:
                return "";
            }
          }),
        ];
        return rowData;
      });
      const departmentTitle = [`Department: ${department}`];
      const allData = [departmentTitle, headers, ...data];
      const ws = XLSX.utils.aoa_to_sheet(allData);
      const columnWidths = [
        { wch: 5 }, // SL
        { wch: 20 }, // E_Name
        { wch: 12 }, // E_Code
        { wch: 8 }, // Gender
        { wch: 12 }, // DOJ
        { wch: 15 }, // Cat
        { wch: 15 }, // Des
        { wch: 5 }, // P
        { wch: 5 }, // A
        { wch: 5 }, // H
        { wch: 5 }, // WO
        { wch: 5 }, // LWA
        { wch: 5 }, // CL
        { wch: 5 }, // AL
        { wch: 5 }, // SL
        { wch: 5 }, // SP
        { wch: 5 }, // ML
        { wch: 5 }, // MH
        { wch: 5 }, // EH
        ...Array.from({ length: daysInMonth }, () => ({ wch: 4 })),
      ];
      ws["!cols"] = columnWidths;
      const range = { s: { r: 0, c: 0 }, e: { r: 0, c: headers.length - 1 } };
      if (!ws["!merges"]) ws["!merges"] = [];
      ws["!merges"].push(range);
      XLSX.utils.book_append_sheet(wb, ws, sanitizedDepartment);
    });
    const fileName = `MusterRoll_${selectedMonth || "report"}.xlsx`;
    XLSX.writeFile(wb, fileName);
  };

  const totalPages = Math.ceil(filteredItems.length / itemsPerPage);
  const currentData = filteredItems.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  useEffect(() => {
    setCurrentPage(1);
  }, [searchText]);

  function formatDate(inputDate) {
    const [year, month, day] = inputDate.split("-");
    return `${day} ${month} ${year}`;
  }

  return (
    <>
      <Breadcrumb title="Muster Roll" />
      <div className="flex flex-wrap items-center gap-3 mb-4">
        <div className="flex items-center">
          <input
            type="month"
            value={selectedMonth}
            onChange={handleMonthChange}
            className="border rounded p-2 h-[38px]"
          />
        </div>
        <div className="flex gap-2">
          <button
            className="btn btn-primary h-[38px]"
            onClick={() => {
              claerSession(); // Clears the EmpId from sessionStorage
              fetchMusterrollData(); // Then fetches attendance
              handleClearFilter();
            }}
          >
            Show Attendance
          </button>

          <button onClick={exportToExcel} className="btn btn-success h-[38px]">
            Excel Export
          </button>
          <button
            onClick={() => exportToPdf(selectodMethodName)}
            className="btn btn-danger h-[38px]"
          >
            Download PDF
          </button>
        </div>
        <div className="flex-1 min-w-[250px] max-w-[400px]">
          <input
            type="search"
            className="w-full p-2 border rounded h-[38px]"
            placeholder="Search by Name/code/dep/cat/des"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
          />
        </div>
        <div className="flex flex-wrap items-center gap-2">
          <div className="min-w-[150px]">
            <select
              id="filter-method"
              name="filter-method"
              className="w-full px-3 py-2 border border-gray-400 rounded-md h-[38px]"
              value={filterMethod}
              onChange={(e) => setFilterMethod(e.target.value)}
            >
              <option value="">Filter By</option>
              <option value="CategoryId">Category</option>
              <option value="ProfitCenterID">Profit Center</option>
              <option value="GroupId">Group</option>
              <option value="DesignationId">Designation</option>
              {isAdmin === 1 && (
                <option value="DepartmentID">Department</option>
              )}
            </select>
          </div>
          <div className="min-w-[150px]">
            <select
              id="dynamic-options"
              name="dynamic-options"
              className="w-full px-3 py-2 border border-gray-400 rounded-md h-[38px]"
              onChange={(e) => {
                const selectedOption = dropdownOptions?.find(
                  (option) => option.Name?.toString() === e.target.value
                );
                if (selectedOption) {
                  handleFilterChange(filterMethod, selectedOption.Name);
                }
              }}
            >
              <option value="">Choose One</option>
              {dropdownOptions?.length > 0 &&
                dropdownOptions?.map((option) => (
                  <option key={option.Id} value={option.Name}>
                    {option.Name}
                  </option>
                ))}
            </select>
          </div>
          <button
            onClick={handleClearFilter}
            className="btn btn-danger h-[38px]"
          >
            Clear
          </button>
        </div>
      </div>
      <div className="bg-bg-dark rounded-lg shadow-light md:p-20 p-15">
        {loading ? (
          <div className="text-center py-4">Loading...</div>
        ) : (
          <div
            className="overflow-auto"
            style={{ maxHeight: "calc(100vh - 200px)" }}
          >
            <div className="p-4">
              <div className="flex flex-wrap gap-4 items-center">
                <div className="flex items-center">
                  <span className="w-8 h-8 flex items-center justify-center border border-gray-300 text-gray-700 font-bold rounded-full mr-2">
                    P
                  </span>
                  <span>Attendance Approved</span>
                </div>
                <div className="flex items-center">
                  <span className="w-8 h-8 flex items-center justify-center border border-gray-300 text-gray-700 font-bold rounded-full mr-2">
                    A
                  </span>
                  <span>Attendance Not Approved</span>
                </div>
                <div className="flex items-center">
                  <span className="w-8 h-8 flex items-center justify-center border border-gray-300 text-gray-700 font-bold rounded-full mr-2">
                    LWA
                  </span>
                  <span>Leave Without Allowance</span>
                </div>
                <div className="flex items-center">
                  <span className="w-8 h-8 flex items-center justify-center border border-gray-300 text-gray-700 font-bold rounded-full mr-2">
                    WO
                  </span>
                  <span>Weekly Off</span>
                </div>
                <div className="flex items-center">
                  <span className="w-8 h-8 flex items-center justify-center border border-gray-300 text-gray-700 font-bold rounded-full mr-2">
                    CL
                  </span>
                  <span>Casual Leave</span>
                </div>
                <div className="flex items-center">
                  <span className="w-8 h-8 flex items-center justify-center border border-gray-300 text-gray-700 font-bold rounded-full mr-2">
                    SL
                  </span>
                  <span>Sick Leave</span>
                </div>
                <div className="flex items-center">
                  <span className="w-8 h-8 flex items-center justify-center border border-gray-300 text-gray-700 font-bold rounded-full mr-2">
                    AL
                  </span>
                  <span>Annual Leave</span>
                </div>
                <div className="flex items-center">
                  <span className="w-8 h-8 flex items-center justify-center border border-gray-300 text-gray-700 font-bold rounded-full mr-2">
                    SP
                  </span>
                  <span>Special Leave</span>
                </div>
                <div className="flex items-center">
                  <span className="w-8 h-8 flex items-center justify-center border border-gray-300 text-gray-700 font-bold rounded-full mr-2">
                    ML
                  </span>
                  <span>Maternity Leave</span>
                </div>
                <div className="flex items-center">
                  <span className="w-8 h-8 flex items-center justify-center border border-gray-300 text-gray-700 font-bold rounded-full mr-2">
                    MH
                  </span>
                  <span>Morning HalfDay</span>
                </div>
                <div className="flex items-center">
                  <span className="w-8 h-8 flex items-center justify-center border border-gray-300 text-gray-700 font-bold rounded-full mr-2">
                    EH
                  </span>
                  <span>Evening HalfDay</span>
                </div>
                <div className="flex items-center">
                  <span className="w-8 h-8 flex items-center justify-center border border-gray-300 text-gray-700 font-bold rounded-full mr-2">
                    H
                  </span>
                  <span>Holiday</span>
                </div>
              </div>
            </div>
            <table className="w-full min-w-[1750px]">
              <thead>
                <tr>
                  <th
                    align="left"
                    className="bg-bg-light-100 p-3 w-[100px] sticky top-0"
                  >
                    Sl
                  </th>
                  <th
                    align="left"
                    className="bg-bg-light-100 p-3 w-[150px] sticky top-0"
                  >
                    E_Name
                  </th>
                  <th
                    align="left"
                    className="bg-bg-light-100 p-3 w-[150px] sticky top-0"
                  >
                    E_Code
                  </th>
                  <th
                    align="left"
                    className="bg-bg-light-100 p-3 w-[150px] sticky top-0"
                  >
                    Gender
                  </th>
                  <th
                    align="left"
                    className="bg-bg-light-100 p-3 w-[150px] sticky top-0"
                  >
                    DOJ
                  </th>
                  <th
                    align="left"
                    className="bg-bg-light-100 p-3 w-[150px] sticky top-0"
                  >
                    Department
                  </th>
                  <th
                    align="left"
                    className="bg-bg-light-100 p-3 w-[150px] sticky top-0"
                  >
                    Category
                  </th>
                  <th
                    align="left"
                    className="bg-bg-light-100 p-3 w-[150px] sticky top-0"
                  >
                    Designation
                  </th>
                  <th
                    align="left"
                    className="bg-bg-light-100 p-3 w-[150px] sticky top-0"
                  >
                    P
                  </th>
                  <th
                    align="left"
                    className="bg-bg-light-100 p-3 w-[150px] sticky top-0"
                  >
                    A
                  </th>
                  <th
                    align="left"
                    className="bg-bg-light-100 p-3 w-[150px] sticky top-0"
                  >
                    LWA
                  </th>
                  <th
                    align="left"
                    className="bg-bg-light-100 p-3 w-[150px] sticky top-0"
                  >
                    WO
                  </th>
                  <th
                    align="left"
                    className="bg-bg-light-100 p-3 w-[150px] sticky top-0"
                  >
                    H
                  </th>
                  <th
                    align="left"
                    className="bg-bg-light-100 p-3 w-[150px] sticky top-0"
                  >
                    CL
                  </th>
                  <th
                    align="left"
                    className="bg-bg-light-100 p-3 w-[150px] sticky top-0"
                  >
                    AL
                  </th>
                  <th
                    align="left"
                    className="bg-bg-light-100 p-3 w-[150px] sticky top-0"
                  >
                    SL
                  </th>
                  <th
                    align="left"
                    className="bg-bg-light-100 p-3 w-[150px] sticky top-0"
                  >
                    SP
                  </th>
                  <th
                    align="left"
                    className="bg-bg-light-100 p-3 w-[150px] sticky top-0"
                  >
                    ML
                  </th>
                  <th
                    align="left"
                    className="bg-bg-light-100 p-3 w-[150px] sticky top-0"
                  >
                    MH
                  </th>
                  <th
                    align="left"
                    className="bg-bg-light-100 p-3 w-[150px] sticky top-0"
                  >
                    EH
                  </th>
                  {daysInMonth > 0 &&
                    Array.from({ length: daysInMonth }, (_, i) => (
                      <th
                        key={i + 1}
                        align="center"
                        className="bg-bg-light-100 p-3 w-[40px] sticky top-0"
                      >
                        {i + 1}
                      </th>
                    ))}
                </tr>
              </thead>
              <tbody>
                {currentData && currentData.length > 0 ? (
                  currentData.map((item, index) => {
                    const globalIndex =
                      (currentPage - 1) * itemsPerPage + index + 1;
                    return (
                      <tr className="hover:bg-bg-light" key={index}>
                        <td className="p-3 border-t border-border w-[100px]">
                          {globalIndex}
                        </td>
                        <td className="p-3 border-t border-border w-[150px]">
                          {item.employee}
                        </td>
                        <td className="p-3 border-t border-border w-[120px]">
                          {item.labourId}
                        </td>
                        <td className="p-3 border-t border-border w-[80px]">
                          {item.gender}
                        </td>
                        <td className="p-3 border-t border-border w-[120px]">
                          {formatDate(item.dateOfJoin)}
                        </td>
                        <td className="p-3 border-t border-border w-[150px]">
                          {item.department}
                        </td>
                        <td className="p-3 border-t border-border w-[200px]">
                          {item.category}
                        </td>
                        <td className="p-3 border-t border-border w-[100px]">
                          {item.designation}
                        </td>
                        <td className="p-3 border-t border-border w-[100px]">
                          {item.totalPresent}
                        </td>
                        <td className="p-3 border-t border-border w-[100px]">
                          {item.totalAbsent}
                        </td>
                        <td className="p-3 border-t border-border w-[100px]">
                          {item.totalYellowppi}
                        </td>
                        <td className="p-3 border-t border-border w-[100px]">
                          {item.weeklyOff ? item.weeklyOff : "0"}
                        </td>
                        <td className="p-3 border-t border-border w-[100px]">
                          {item.totalHolidays}
                        </td>
                        <td className="p-3 border-t border-border w-[100px]">
                          {item.totalCasualLeave}
                        </td>
                        <td className="p-3 border-t border-border w-[100px]">
                          {item.totalAnnualLeave}
                        </td>
                        <td className="p-3 border-t border-border w-[100px]">
                          {item.totalSickLeave}
                        </td>
                        <td className="p-3 border-t border-border w-[100px]">
                          {item.totalSpecialLeave}
                        </td>
                        <td className="p-3 border-t border-border w-[100px]">
                          {item.totalMaternityLeave}
                        </td>
                        <td className="p-3 border-t border-border w-[100px]">
                          {item.totalMorningHalfDay}
                        </td>
                        <td className="p-3 border-t border-border w-[100px]">
                          {item.totalEveningHalfDay}
                        </td>
                        {item.children.map((res, key) => (
                          <td
                            key={key}
                            align="center"
                            className="p-3 border-t border-border w-[40px]"
                          >
                            {renderStatusIcon(res.status, res.leaveType)}
                          </td>
                        ))}
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan={15 + daysInMonth} className="text-center p-4">
                      No data available
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
            <div className="flex items-center justify-center gap-2 my-5 font-sans">
              <button
                onClick={() => goToPage(currentPage - 1)}
                disabled={currentPage === 1}
                className="px-3 py-2 text-sm font-medium bg-gray-100 rounded-md transition-colors hover:bg-gray-200 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                Previous
              </button>
              {Array.from({ length: totalPages }, (_, index) => (
                <button
                  key={index + 1}
                  onClick={() => goToPage(index + 1)}
                  className={`w-9 h-9 flex items-center justify-center rounded-md text-sm transition-colors
                    ${
                      currentPage === index + 1
                        ? "bg-blue-600 text-white font-semibold"
                        : "bg-gray-100 text-gray-700 hover:bg-gray-200"
                    }`}
                >
                  {index + 1}
                </button>
              ))}
              <button
                onClick={() => goToPage(currentPage + 1)}
                disabled={currentPage === totalPages}
                className="px-3 py-2 text-sm font-medium bg-gray-100 rounded-md transition-colors hover:bg-gray-200 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                Next
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
